import React from "react";

export default React.createContext(null);
export const checkActive = (tabKey, active) =>
  tabKey.toString() === active.toString();
